import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { formInitialState } from './state';
import { FB_NAMESPACE } from './constants';
import { setFacebookSdkLoadingStart, setFacebookSdkLoadingEnd, setFacebookFetchToken, setFacebookFetchTokenEnd, setFacebookToken, setFacebookUserEmailTo, setFacebookUserEmailUpdateFailed, } from './actions';
const getFacebookNewState = (state, update) => {
    return {
        ...state,
        [FB_NAMESPACE]: {
            ...state[FB_NAMESPACE],
            ...update,
        },
    };
};
export const facebookOverlayReducer = reducerWithInitialState(formInitialState)
    .case(setFacebookSdkLoadingStart, state => getFacebookNewState(state, {
    loadingSdk: true,
}))
    .case(setFacebookSdkLoadingEnd, state => getFacebookNewState(state, {
    loadingSdk: false,
}))
    .case(setFacebookFetchToken, state => getFacebookNewState(state, {
    fetchingToken: true,
}))
    .case(setFacebookFetchTokenEnd, state => getFacebookNewState(state, {
    fetchingToken: false,
}))
    .case(setFacebookToken, (state, token) => getFacebookNewState(state, {
    accessToken: token,
}))
    .case(setFacebookUserEmailTo, (state, passwordResetEmail) => getFacebookNewState(state, {
    passwordResetEmail,
}))
    .case(setFacebookUserEmailUpdateFailed, (state, payload) => getFacebookNewState(state, {
    errors: {
        ...payload,
    },
}));
export default facebookOverlayReducer;
//# sourceMappingURL=reducer.js.map